<script setup lang="ts">
</script>
<template>
    <div class="mainpart-vertical">
        <h1 class="h1">
            隐私权政策——奕鸣商品询价APP
        </h1>
        <div class="text">
            【金华市奕鸣科技有限公司】（以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
            请在使用我们的产品（即奕鸣商品询价APP）前，仔细阅读并了解本《隐私权政策》。
        </div>
        <h2 class="h2">
            一.我们如何收集和使用您的个人信息
        </h2>
        <div class="text">
            个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
            我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：
        </div>
        <h3 class="h3">
            1.1 成为用户
        </h3>
        <div class="text">
            为完成创建账号，您需提供以下信息：您的姓名、手机号、创建的用户名和密码等信息。
            您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。
            上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。
        </div>
        <h3 class="h3">
            1.2 内部数据分析和研究，第三方SDK统计服务，改善我们的产品或服务
        </h3>
        <div class="text">
            我们收集数据是根据您与我们的互动和您所做出的选择，包括您的隐私设置以及您使用的产品和功能。我们收集的数据可能包括:
        </div>
        <div class="text">
            SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、国际移动设备识别码（IMEI）、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。
        </div>
        <h3 class="h3">
            1.3SDK特别说明
        </h3>
        <div class="text">
            本产品集成了com.alipay(支付宝|mPaaS|阿里乘车码|芝麻认证|实人认证)等SDK,用于用户进行扫码。该SDK采集的数据、发送的服务器地址、以及数据用途说明：
            会有数据大盘统计，发送至 https://mpaas-mas-loggw.aliyuncs.com
        </div>
        <h3 class="h3">
            1.4开发特别说明
        </h3>
        <div class="text">
            我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡
            IMSI信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。
        </div>
        <h2 class="h2">
            二.我们如何共享、转让、公开披露您的个人信息
        </h2>
        <h3 class="h3">
            2.1 共享
        </h3>
        <div class="text">
            我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外：
        </div>
        <div class="text">
            1. 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        </div>
        <div class="text">
            2. 我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
        </div>
        <div class="text">
            3. 与我们的关联公司共享：您的个人信息可能会与我们关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
        </div>
        <div class="text">
            4.与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。
        </div>
        <div class="text">
            例如，我们聘请来提供第三方数据统计和分析服务的公司可能需要采集和访问个人数据以进行数据统计和分析。在这种情况下，这些公司
            必须遵守我们的数据隐私和安全要求。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。
            对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
        </div>

        <h3 class="h3">
            2.2 转让
        </h3>
        <div class="text">
            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </div>
        <div class="text">
            1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        </div>
        <div class="text">
            2. 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
        </div>

        <h3 class="h3">
            2.3 公开披露
        </h3>
        <div class="text">
            我们仅会在以下情况下，公开披露您的个人信息：
        </div>
        <div class="text">
            1. 获得您明确同意后；
        </div>
        <div class="text">
            2. 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
        </div>


        <h2 class="h2">
            三.我们如何保护您的个人信息
        </h2>
        <div class="text">
            1.我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
        </div>
        <div class="text">
            例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受
            SSL 加密保护；我们同时对我们网站提供 https
            安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </div>
        <div class="text">
            2. 我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
        </div>
        <div class="text">
            3. 互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他我们用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。
        </div>
        <div class="text">
            4.
            互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </div>
        <div class="text">
            5.
            在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
            同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
        </div>


        <h2 class="h2">
            四. 您的权利
        </h2>
        <div class="text">
            按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
        </div>
        <h3 class="h3">
            4.1. 访问您的个人信息
        </h3>
        <div class="text">
            您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，您可以通过应用中的个人信息页面进行查看。
        </div>
        <h3 class="h3">
            4.2. 更正您的个人信息
        </h3>
        <div class="text">
            当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过应用的个人信息页面进行修改操作。
        </div>
        <h3 class="h3">
            4.3. 删除您的个人信息
        </h3>
        <div class="text">
            在以下情形中，您可以向我们提出删除个人信息的请求：
        </div>
        <div class="text">
            - 如果我们处理个人信息的行为违反法律法规；
        </div>
        <div class="text">
            - 如果我们处理个人信息的行为违反法律法规；
        </div>
        <div class="text">
            - 如果我们收集、使用您的个人信息，却未征得您的同意；
        </div>
        <div class="text">
            - 如果我们处理个人信息的行为违反了与您的约定；
        </div>
        <div class="text">
            - 如果您不再使用我们的产品或服务；
        </div>
        <div class="text">
            - 如果您不再使用我们的产品或服务；
        </div>
        <div class="text">
            - 如果我们不再为您提供产品或服务。
        </div>
        <div class="text">
            您可以通过应用注销账号时会发送删除个人信息请求，若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        </div>
        <div class="text">
            当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
        </div>

        <h2 class="h2">
            五. 本隐私权政策如何更新
        </h2>
        <div class="text">
            我们可能适时会对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束。
        </div>
        <h2 class="h2">
            六. 如何联系我们
        </h2>
        <div class="text">
            如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：
            邮箱：【JinHuaYiMing@163.com】
        </div>
    </div>
</template>
<style scoped>
.mainpart-vertical {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
}

.h1 {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 46px;
}

.h2 {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 24px;
}

.h3 {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 18px;
}

.text {
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 14px;
}
</style>